export const isOrderCancelled = (o) => {
    return ['CANCEL', 'CANCELLED', 'CANCELED', 'REJECTED'].includes(o.order_status.toUpperCase());
};
